import { render, staticRenderFns } from "./bar.vue?vue&type=template&id=0ea0035f&scoped=true&lang=html&"
import script from "./bar.vue?vue&type=script&lang=js&"
export * from "./bar.vue?vue&type=script&lang=js&"
import style0 from "./bar.vue?vue&type=style&index=0&id=0ea0035f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea0035f",
  null
  
)

component.options.__file = "bar.vue"
export default component.exports